import {IStateParamsService, IStateService} from "angular-ui-router";
import {LoDashStatic} from "lodash";

const _ = <LoDashStatic> require('lodash');

class ArticlesProfileController {
    searchResult;
    tableDefinition = {
        promise: null
    };

    constructor(private toastService, private $state: IStateService, private $stateParams: IStateParamsService, private ArticleProfiles) {
        let articleNo = this.$stateParams["articleNo"];
        if (articleNo) {
            this.tableDefinition.promise = ArticleProfiles.findArticle({articleId: articleNo}, {}).$promise.then(
                (results) => {
                    this.searchResult = results;
                    this.searchResult.lines = _.orderBy(results.lines.map(article => {
                        article.confirmedDate =
                            article.confirmedDate ? new Date(article.confirmedDate)
                                : article.availableDate ? new Date(article.availableDate)
                                : null;
                        article.canChangeDate =
                            article.orderType !== 'PURCHASE_ORDER' &&
                            article.orderType !== 'CUSTOMER_ORDER' &&
                            !article.structureArticle;
                        return article;
                    }), ['confirmedDate'], ['asc']);
                },
                (error) => this.toastService.parseError(error)
            );
        } else {
            toastService.showSimpleToast("Ingen aktiv vare", 3000);
        }
    }
}

class ArticlesProfileOptions implements ng.IComponentOptions {
    controllerAs = 'c';
    public controller: string = "rkcArticlesProfileController";
    public template: any = require('./articlesProfile.html');

}

rkcApp.controller("rkcArticlesProfileController", ['toastService', '$state', '$stateParams', 'ArticleProfiles', function (toastService, $state, $stateParams, ArticleProfiles) {
    return new ArticlesProfileController(toastService, $state, $stateParams, ArticleProfiles);
}])
    .component("rkcArticlesProfile", new ArticlesProfileOptions());



/** WEBPACK FOOTER **
 ** ./src/app/components/main/views/articleProfile/articlesProfile.ts
 **/